// Watchdog na zamrznutí hlavního vlákna – odpovídá Chrome hlášce "Stránka nereaguje".
// Heartbeat hlídá, jestli mezi ticky neuběhlo víc času, než mělo. Když ano, bylo hlavní
// vlákno zablokované (dlouhý synchronní JS) → po odblokování to zaloguje na server.
// Stall nedokáže zastavit (vlákno je z principu blokované), jen ho zpětně zaznamená.
const TICK_MS = 1000;
const STALL_MS = 10000;           // stall delší než tohle bereme jako zamrznutí
const BEACON_THROTTLE_MS = 60000; // max jeden report za minutu
const BEACON_URL = '/main/js-guard/freeze';

class FreezeWatchdogExtension {
    initialize(naja) {
        if (window.__freezeWatchdogStarted) return;
        window.__freezeWatchdogStarted = true;

        this.lastClick = null;
        this.lastNaja = null;
        this.lastBeaconAt = 0;

        document.addEventListener('click', (e) => {
            if (e.target) this.lastClick = this.describe(e.target);
        }, true);

        naja.addEventListener('before', (e) => {
            this.lastNaja = e.detail?.url || null;
        });

        let paused = document.hidden;
        let expected = performance.now() + TICK_MS;

        // Na pozadí prohlížeč throttluje časovače – to není zamrznutí, takže pauzujeme.
        document.addEventListener('visibilitychange', () => {
            if (document.hidden) {
                paused = true;
            } else {
                paused = false;
                expected = performance.now() + TICK_MS;
            }
        });

        setInterval(() => {
            const now = performance.now();
            const drift = now - expected;
            expected = now + TICK_MS;

            if (paused || document.hidden) return;
            if (drift > STALL_MS) this.report(Math.round(drift));
        }, TICK_MS);
    }

    describe(el) {
        try {
            const tag = el.tagName ? el.tagName.toLowerCase() : '';
            const id = el.id ? '#' + el.id : '';
            const cls = (typeof el.className === 'string' && el.className.trim())
                ? '.' + el.className.trim().split(/\s+/).join('.')
                : '';
            const text = (el.textContent || '').trim().slice(0, 40);
            return (tag + id + cls + (text ? ` "${text}"` : '')).slice(0, 200);
        } catch (e) {
            return null;
        }
    }

    report(stallMs) {
        const now = Date.now();
        if (now - this.lastBeaconAt < BEACON_THROTTLE_MS) return;
        this.lastBeaconAt = now;

        const data = {
            type: 'freeze',
            page: window.location.href,
            stallMs,
            lastClick: this.lastClick,
            lastNaja: this.lastNaja,
            ts: new Date().toISOString(),
        };

        console.warn(`[FreezeWatchdog] Hlavní vlákno zamrzlo na ~${stallMs} ms – nahlášeno na server.`, data);

        try {
            const body = JSON.stringify(data);
            if (navigator.sendBeacon) {
                navigator.sendBeacon(BEACON_URL, new Blob([body], { type: 'application/json' }));
            } else {
                fetch(BEACON_URL, {
                    method: 'POST',
                    body,
                    headers: { 'Content-Type': 'application/json' },
                    keepalive: true,
                });
            }
        } catch (e) {
            // Logování nesmí nikdy shodit appku.
        }
    }
}

export default FreezeWatchdogExtension;
